import { cn } from '@/lib/utils/helpers'

const STYLES: Record<string, string> = {
  AUTO_MAPPED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  WOULD_AUTO_MAP: 'bg-sky-50 text-sky-700 border-sky-200',
  MANUAL_REVIEW: 'bg-amber-50 text-amber-700 border-amber-200',
  UNMATCHABLE: 'bg-slate-100 text-slate-700 border-slate-200',
  FAILED: 'bg-rose-50 text-rose-700 border-rose-200',
  MANUALLY_MAPPED: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  PENDING: 'bg-white text-slate-600 border-slate-200',
  ENABLED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  SHADOW: 'bg-amber-50 text-amber-700 border-amber-200',
  DISABLED: 'bg-rose-50 text-rose-700 border-rose-200',
  COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  RUNNING: 'bg-sky-50 text-sky-700 border-sky-200',
  PARTIAL: 'bg-amber-50 text-amber-700 border-amber-200',
  NOT_SCHEDULED: 'bg-slate-100 text-slate-600 border-slate-200',
}

export function MatchStatusBadge({ value }: { value?: string | null }) {
  const label = String(value || 'PENDING').replace(/_/g, ' ')
  return (
    <span
      className={cn(
        'inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize',
        STYLES[String(value || 'PENDING')] || STYLES.PENDING,
      )}
    >
      {label.toLowerCase()}
    </span>
  )
}
